import { render, staticRenderFns } from "./CampagnaGeneralData.vue?vue&type=template&id=4349f11c&"
import script from "./CampagnaGeneralData.vue?vue&type=script&lang=ts&"
export * from "./CampagnaGeneralData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports